import { $, _ } from "../../../helpers/dom-selectors.js";
import App from "./init/app.js";
(async function () {
    const overlays = $(document, '.overlay');
    overlays.forEach(overlay => overlay.classList.remove('no-display'));
    const app = App({
        settingsBtn: _('settingsBtn'),
        settingsOverlay: _('settingsOverlay'),
        header: _('header'),
        logo: _('logo'),
        addBtn: _('addBtn'),
        reOrderBtn: _('reOrderBtn')
    });
    app.resize();
    window.addEventListener('app-event', (e) => {
        app.executeEvent(e.detail.action);
    });
    window.addEventListener('app-event-with-data', (e) => {
        app.executeEventWithData(e.detail);
    });
    window.addEventListener('form-event-with-data', (e) => {
        app.executeFormEventWithData(e.detail);
    });
    window.addEventListener('file-event-with-data', (e) => {
        app.executeFileEventWithData(e.detail);
    });
    window.addEventListener('resize', app.resize);
    document.documentElement.addEventListener('touchstart', function (e) { }); //hover behaviour on touch devices
})();
